import Country from "./Country";
import EntityStats from "./EntityStats";
import CHElementScale from "./enums/CHElementScale";
import HeritageCategories from "./enums/HeritageCategories";
import SpatialDimension from "./enums/SpatialDimensions";
import Material from "./Material";
import Municipality from "./Municipality";
import PathInfo from "./PathInfo";
import Province from "./Province";

class CHElement {
  constructor(
    public id_user: number,
    public name: string,
    public description: string,
    public id_site: number | undefined,
    public heritage_category: HeritageCategories,
    public start_year: number,
    public end_year: number,
    public approximate_date: boolean,
    public icon: number | undefined,
    public scale: CHElementScale,
    public spatial_dimension: SpatialDimension,
    public address: string,
    public author: string,
    public cultural_sphere: string,
    public id_country: number,
    public id_province?: number | undefined,
    public id_municipality?: number | undefined,
    // create and edit
    public chelement_materials?: Material[],
    public latitude?: number | undefined,
    public longitude?: number | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: string | undefined,
    public icon_path?: string | undefined,
    public parent?: PathInfo,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined,
    public start_year_bc?: boolean,
    public end_year_bc?: boolean,
    // read
    public materials?: Material[],
    public country?: Country,
    public province?: Province,
    public municipality?: Municipality,
    // local information only
    public local_country?: Country,
    public local_province?: Province,
    public local_municipality?: Municipality
  ) {}

  public static EmptyInstance(): CHElement {
    return new CHElement(
      -1,
      "",
      "",
      undefined,
      HeritageCategories.Movable,
      0,
      0,
      false,
      -1,
      CHElementScale.Object,
      SpatialDimension._2D,
      "",
      "",
      "",
      -1
    );
  }
}

export default CHElement;
